<div class="container">
    <div class="top-section">
        <div class="back-icon-container">
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
        </div>
        <p class="order-heading">{{ "order.heading.yourOrder" | translate }}</p>
    </div>

    <div class="spinner-container">
        <mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>
    </div>
    <div class="bottom-section" *ngIf="orders.length; else noOrders">
        @for (order of orders; track $index) {
        <div class="order-section">
            <div class="each-order-top-section">
                <div class="each-order-top-section-left">
                    <p class="order-place-section">
                        <span
                            >ORDER STATUS: <span class="order-status">{{ order.orderStatus }}</span></span
                        >
                        <span>{{ order.updatedAt | date: "dd MMM YYY" }}</span>
                    </p>
                    <p class="total-section">
                        <span>TOTAL</span>
                        <strong>Rs. {{ order.originalTotal }}</strong>
                    </p>
                    <p class="ship-section">
                        <span>SHIP TO</span>
                        <span class="ship-value"
                            ><span class="ship-value-name">{{ order.customerName }}</span>
                            <mat-icon [matTooltip]="getAddressTooltip(order)" class="arrow-down-icon"
                                >expand_more</mat-icon
                            ></span
                        >
                    </p>
                    <p class="orderId-label">
                        ORDER ID: #<strong> {{ order.id }} </strong>
                    </p>
                </div>
            </div>
            <div class="each-order-bottom-section">
                <div class="order-item-left-section">
                    <!-- Only 3 items will be shown -->
                    @for (item of order.orderItems?.slice(0,3); track $index) {
                    <div class="order-item">
                        <img
                            class="order-image"
                            [src]="item.product?.images?.imagesUrl?.[0]"
                            (click)="onClickProduct(item.productId)"
                        />
                        <div class="name-price">
                            <span
                                class="product-name"
                                [matTooltipShowDelay]="800"
                                [matTooltipHideDelay]="500"
                                [matTooltip]="item.product?.name"
                                matTooltipPosition="above"
                                >{{ item.product?.name }}</span
                            >

                            <span *ngIf="item.product?.modelQuantityJson">
                                ({{ item.product?.modelQuantityJson?.totalBlock }}
                                {{ "order.orderDetails.shape" | translate }})
                            </span>
                        </div>
                    </div>
                    }
                    <!-- This will appear when product is more than 3  -->
                    @if ((order.orderItems?.length ?? 0) > 3) {
                    <div class="more-items">
                        <span (click)="navigateOrderPage(order.id)"
                            >+{{ (order.orderItems?.length ?? 0) - 3 }} more items</span
                        >
                    </div>
                    }
                </div>

                <div class="order-item-right-section">
                    <app-button
                        variant="white"
                        buttonClass="explore-btn shadow-btn"
                        (onClick)="navigateOrderPage(order.id)"
                    >
                        {{ "View Order" }}
                    </app-button>

                    <app-button
                        variant="white"
                        [disabled]="!isReturnable(order)"
                        buttonClass="explore-btn shadow-btn"
                        (onClick)="navigateItemList(order, 'return')"
                    >
                        Return item(s)
                    </app-button>

                    <app-button
                        variant="white"
                        [disabled]="!isExchangeable(order)"
                        buttonClass="explore-btn shadow-btn"
                        (onClick)="navigateItemList(order, 'exchange')"
                    >
                        Exchange item(s)
                    </app-button>

                    <app-button
                        variant="white"
                        [disabled]="!isAbleToReview(order)"
                        buttonClass="explore-btn shadow-btn"
                        (onClick)="navigateReviewPage(order.id)"
                    >
                        Write a Product Feedback
                    </app-button>

                    <app-button
                        variant="white"
                        [disabled]="!isItemOrderedOrPackedExist(order)"
                        buttonClass="explore-btn shadow-btn"
                        (onClick)="navigateItemList(order, 'cancel')"
                    >
                        Cancel item(s)
                    </app-button>
                </div>
            </div>
        </div>
        }
    </div>

    <ng-template #noOrders>
        <div class="no-orders-card" *ngIf="!loading">
            <div class="no-orders-container">
                <img class="search" src="https://funfigz-assets-public.s3.ap-south-1.amazonaws.com/seach-lens.png" />
                <h2>NO ORDER FOUND</h2>
                <p class="no-orders">Looks like you haven't made your order yet.</p>
                <br />
                <app-button variant="hero" (onClick)="goBackToProducts()">Back to Products</app-button>
            </div>
        </div>
    </ng-template>

    <div class="view-more-btn-container">
        <app-button variant="hero" *ngIf="showViewMoreButton()" (click)="loadMoreOrders()">
            {{ "order.button.viewMoreBtn" | translate }}
        </app-button>
    </div>
</div>
